<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div class="row" v-if="cards">
          <div class="col-md-3">
            <div class="form-group">
              <label>Карта для оплаты</label>
              <select class="form-control" v-model="selectedCardId">
                <option value="0">Выберите карту</option>
                <option v-for="(c, index) in cards" :key="index" :value="c.id">[{{ c.id }}] {{ c.number }} ({{
                    c.balance || 0
                  }}) <span v-if="c.is_block"> - блок</span>
                </option>
              </select>
            </div>
          </div>
          <div class="col-md-8 flex">
            <div class="form-group">
              <label>Период времени</label>
              <div>
                <DateRangePicker ref="selectedRange"/>
              </div>
            </div>
            <div class="ml-4">
              <div>
                <label><input type="checkbox" v-model="filter.incomes_only"> Только поступления</label>
              </div>
              <div>
                <label><input type="checkbox" v-model="filter.outcomes_only"> Только расходы</label>
              </div>
            </div>
            <div class="flex">
              <div class="ml-1">
                <label>Показать типы операций</label>
                <multiselect
                  v-model="selectedTypes"
                  :options="Object.values(types)"
                  :multiple="true"
                  label="title"
                  track-by="title"
                  :placeholder="'Выберите вариант'"
                  select-label="Выбрать"
                  deselect-label="Удалить">
                </multiselect>
              </div>
              <div class="ml-1">
                <label>Исключить типы операций</label>
                <multiselect
                  v-model="selectedIgnoredTypes"
                  :options="Object.values(types)"
                  :multiple="true"
                  label="title"
                  track-by="title"
                  :placeholder="'Выберите вариант'"
                  select-label="Выбрать"
                  deselect-label="Удалить">
                </multiselect>
              </div>
            </div>
          </div>
          <div class="col-md-1 text-right">
            <LoadingButton
              title="Показать"
              :loading="loading"
              :color="$constants.PRIMARY_COLOR"
              :onClick="() => getRecords(1)"
              className="btn btn-outline-info"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>

        <template v-if="records && records.length">
          <div><h5>Всего за период: <strong>{{ total }}</strong></h5></div>
          <div>{{ Object.values(totalConversions).reduce((acc, c) => acc + c, 0) }}</div>
          <table class="table table-sm mt-1 table-hover">
            <thead>
            <tr>
              <th>№</th>
              <th></th>
              <th>карта</th>
              <th>дата</th>
              <th></th>
              <th>сумма</th>
              <th></th>
              <th>сообщение</th>
              <th></th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(r, i) in records">
              <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
              <td>{{ r.id }}</td>
              <td>{{ r.card_id }}</td>
              <td>{{ printDate(moment(r.date).add(3, 'hours')) }}</td>
              <td>{{ r.is_income ? '+' : '-' }}</td>
              <td>{{ r.sum }}</td>
              <td>
                <template v-if="!r.is_income">
                  <select @change="updateRecordType(r)" v-model="r.action_id" class="form-control">
                    <option value="0">нет типа</option>
                    <option v-for="t in types" :value="t.id">{{ t.title }}</option>
                  </select>
                </template>
              </td>
              <td>
                <p>{{ r.message }}</p>
                <p v-if="!r.is_income && r.action_id === 2"><span
                  class="badge badge-success">обмен {{ r.task_id }}</span></p>
              </td>
              <td>{{ r.payment_id }}</td>
              <td></td>
            </tr>
            </tbody>
          </table>
        </template>

        <div class="text-right">
          <paginate v-if="paginator"
                    :page-count="paginator.last_page"
                    :page-range="11"
                    :margin-pages="2"
                    v-model="paginator.current_page"
                    :click-handler="getRecords"
                    :prev-text="'&laquo'"
                    :next-text="'&raquo'"
                    :container-class="'pagination'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :active-class="'active green_btn'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import Paginate from 'vuejs-paginate'
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import DateRangePicker from "@/components/dateSelect/DateRangePicker.vue";
import moment from "moment";
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Paginate,
    LoadingButton,
    DateRangePicker,
    Multiselect,
  },
  data() {
    return {
      selectedCardId: 0,
      filter: {
        outcomes_only: false,
        incomes_only: false,
      },
      types: {
        1: {id: 1, title: 'поддержка карт'},
        2: {id: 2, title: 'TRC обмен'},
        3: {id: 3, title: 'пополнение почтовой карты'},
        4: {id: 4, title: 'возврат'},
      },
      selectedTypes: [],
      selectedIgnoredTypes: [],
      payLink: null,
      cards: null,
      loading: false,
      paginator: null,
      records: null,
      conversions: [],
      detailedConversion: {},
      totalConversions: {},
      total: 0,
    }
  },
  created() {
    this.getCards();
    // this.getRecords();
  },
  methods: {
    moment(date) {
      return moment(date)
    },
    async updateRecordType(record) {
      const {data} = await api.post('cards/income/record', {
        record_id: record.id,
        action: 'updateAction',
        action_id: record.action_id
      });
      if (data.success){
        toastr['success']('Сохранено');
      }else{
        toastr['warning'](data.message || 'Ошибка');
      }
    },
    getConversionByRecord(record) {
      let found = false
      const date = moment(record.date).add(3, 'hours');
      // this.conversions.forEach((c) => {
      //   if (found) return;
      //   if (Math.abs(date.diff(moment(c.updated_at), 'minutes')) <= 2) {
      //     found = c;
      //     this.totalConversions[c.id] = record.sum;
      //   }
      // });
      // this.totalConversions = {...this.totalConversions};
      return found;
    },
    async getCards() {
      const {data} = await api.index('/cards/getCards?noPage=1&disabled=1');
      if (data.success) {
        this.cards = data.records;
      } else {
        toastr['warning'](data.message || 'Карты не загружены');
      }
    },
    async getRecords(page = 1) {
      // if (!this.selectedCardId) return;
      this.records = null;
      this.totalConversions = {};
      this.detailedConversion = {};
      this.loading = true;
      let {data: r_data} = await api.post('/cards/statistics?page=' + page, {
        card_id: this.selectedCardId,
        range: this.$refs.selectedRange.dateRange,
        filter: {...this.filter, selectedTypes: this.selectedTypes, ignoreTypes: this.selectedIgnoredTypes},
      });
      if (r_data.success) {
        const {data, ...pagination} = r_data.records;
        this.paginator = pagination;
        this.total = r_data.total;
        this.conversions = r_data.conversions;
        // data.forEach((r) => {
        // const conv = this.getConversionByRecord(r);
        // if (conv) {
        //   this.detailedConversion[r.id] = conv;
        // }
        // })
        this.records = data;
      } else {
        toastr['warning'](r_data.message || 'Задач не найдено');
      }
      this.loading = false;
    }
  }
}

</script>
